import { render } from "./GroupBookingReferenceObject.vue?vue&type=template&id=0ff881b2&scoped=true"
import script from "./GroupBookingReferenceObject.vue?vue&type=script&lang=js"
export * from "./GroupBookingReferenceObject.vue?vue&type=script&lang=js"

import "./GroupBookingReferenceObject.vue?vue&type=style&index=0&id=0ff881b2&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff881b2"]])

export default __exports__